export default __webpack_public_path__ + "static/media/island.7ca16192.mp4";